//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyMessage from "./empty-message";
import ResultBadge from "./results-components/result-badge";
import ResultSubtitle from "./results-components/result-subtitle";
import Badge from "@Shared/components/general/badge.vue";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ProfileCard from "@Broker/@Modules/clients/board/client-board/components/views-type/dynamic/board-columns/profile-cards/profile-card.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResultsSection",
  components: {
    EmptyMessage,
    ResultBadge,
    ResultSubtitle,
    ProfileAvatar,
    Badge,
    ProfileCard
  },
  props: {
    results: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    noResults() {
      return this.results.length === 0;
    }
  },
  methods: {
    getAnchorText({
      givenName = "",
      familyName = "",
      applicationId,
      filogixId,
      erdExpertApplicationId
    }) {
      const fullName = [givenName, familyName].join(" ");
      const expertIdToUse = erdExpertApplicationId || filogixId || "";
      const filogixExpertId = expertIdToUse && `(${expertIdToUse})`;
      if (this.type === "applications") {
        const appInformation = `- #${applicationId} ${filogixExpertId}`;
        return `${fullName} ${appInformation}`;
      }
      return fullName;
    },
    getAnchor(result) {
      switch (this.type) {
        case "applications":
          return this.getApplicationAnchor(result);
        case "clientProfiles":
          return this.getClientProfilesAnchor(result);
        case "referrers":
          return this.getReferrersAnchor(result);
      }
    },
    getApplicationAnchor({
      applicationId,
      username,
      agentUsername
    }) {
      if (!applicationId) return "#/clients/applications";
      return `#/clients/applications/${username}?agentUsername=${agentUsername}&applicationId=${applicationId}`;
    },
    getClientProfilesAnchor({
      id,
      boardId
    }) {
      return `#/board/${boardId}/profile/${id}`;
    },
    getReferrersAnchor({
      id
    }) {
      return `#/referrers/${id}`;
    },
    closePopover() {
      //eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("popover:close");
    },
    getTypeTitle(type) {
      return this.$t("global.search.resultsSections")[type];
    }
  }
});